import { render, staticRenderFns } from "./NullData.vue?vue&type=template&id=6d3e79cd&scoped=true&"
import script from "./NullData.vue?vue&type=script&lang=js&"
export * from "./NullData.vue?vue&type=script&lang=js&"
import style0 from "./NullData.vue?vue&type=style&index=0&id=6d3e79cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3e79cd",
  null
  
)

export default component.exports